import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

import "./formRender.css"

import { FormValidator } from './validate';
import { renderChildren } from './formRenderReadOnly'

const columnsCSS = {
  "2" : 'columns2',
  "3" : 'columns3',
} as any


const renderChildrenReadOnly = (formTemplate: any, formState: any,  depth = 0 ) => {
  const templateItems = Array.isArray(formTemplate) ? formTemplate : [];
  return templateItems.map((item: any, index: number) => {
    
    if (item.type === 'section'){
      const parent= (depth) ? '' : 'parent'
      const css= (columnsCSS[item.columns]) || ''

      return (
        <div key={`template${index}`} className={`formBlock ${parent}`}>          
          <h2>{item.text||item.label}</h2>
          <div className={css}>
          {renderChildrenReadOnly(item.children, formState, 1)}
          </div>
        </div>
      )
    }
    
          
    if (item.type === 'text') 
      return <div key={index}>{item.text}</div>

      if (item.type === 'bullet') 
      return <li key={index}>{item.text}</li>

      if (item.type === 'bulletList') {
        return (
          <ul>
            {item.items.map((item:any, index:any)=>{
              return <li key={`items${index}`}>{item.text}</li>      
            })}
          </ul>
        )            
      }

    if (item.type === 'paragraph') {
      return <p key={index}>{item.text}</p>
    }

    if (item.type === 'heading') {
        return <h1 key={index}>{item.text}</h1>
    }


      if (item.type === 'textInput') {
            return (
              <div key={index} className='inputBlock' >
                <label id={`label${item.key}`} className='label' htmlFor={item.key}>{item.label}</label>
                <div>
                  <span className='bold'>{formState[item.key]}</span>                  
                </div>
              </div>
            )
        }

        if (item.type === 'staticInput') {
          return (
            <div key={index} className='inputBlock' >
              <label className='label' htmlFor={item.key}>{item.label}</label>
              <div>
              <span>{formState[item.key]}</span>                  
              </div>
            </div>
          )
      }

        if (item.type === 'textAreaInput') {
          return (
            <div key={index} className='inputBlock'>
              <label className='label' htmlFor={item.key}>{item.label}</label>
              <div>
              <span className='bold' >{formState[item.key]}</span>                  
              </div>
            </div>
          )
      }

        if (item.type === 'yesnoInput') {
            return (
                <div key={index} className='inputBlock'>
                    
                    <label  className='label' htmlFor={item.key}>{item.label}</label>
                    <span  className='bold' >{(formState[item.key])? "YES " :"NO "}</span>                  
                </div>
            )
        }

        if (item.type === 'listInput') {
          return (
            <div key={index} className='inputBlock'>
              <label htmlFor={`label${item.key}`}>{item.label}</label>
           
              {item.options.map((option: any, optionIndex: number) => {
                if (formState[item.key] == option.value) 
                  return (
                    <React.Fragment key={optionIndex}>                    
                      <div className='bold label' >{option.label}</div>
                    </React.Fragment>
                  )
              })}
            </div>
          )

        }


        if (item.type === 'dateInput') {
            return (
                <div key={index} className='inputBlock'>
                    <label htmlFor={item.key}>{item.label}</label>
                    <span className='bold' >{formState[item.key]}</span>                  
                </div>
            )
        }

        if (item.type === 'repeater') {
          const items = formState[item.key] || [];
          
          // Show the repeater section even if empty for visibility
          return (
            <div key={index} className='inputBlock'>
              <label style={{ fontStyle: 'italic', color: '#666' }}>
                {item.label.replace('Add ', '')}:
              </label>
              {items.length === 0 ? (
                <div style={{ paddingLeft: '20px', fontStyle: 'italic', color: '#999' }}>
                  None specified
                </div>
              ) : (
                <div>
              {items.map((itemData: any, itemIndex: number) => (
                <div key={itemIndex} style={{ marginBottom: '10px', paddingLeft: '20px', borderLeft: '2px solid #ccc' }}>
                  {item.fields.map((field: any, fieldIndex: number) => {
                    const renderFieldValue = () => {
                      if (field.type === 'listInput') {
                        const selectedOption = field.options?.find((option: any) => option.value === itemData[field.key]);
                        return selectedOption?.label || itemData[field.key] || '—';
                      }
                      if (field.type === 'yesnoInput') {
                        return itemData[field.key] ? 'Yes' : 'No';
                      }
                      return itemData[field.key] || '—';
                    };

                    return (
                      <div key={fieldIndex} style={{ marginBottom: '5px' }}>
                        <span style={{ fontWeight: 'normal' }}>{field.label}: </span>
                        <span className='bold'>{renderFieldValue()}</span>
                      </div>
                    );
                  })}
                </div>
              ))}
                </div>
              )}
            </div>
          );
        }

        if (item.type === 'collapsible') {
          return (
            <div key={index} className='formBlock'>
              <h2>{item.label}</h2>
              <div style={{ paddingLeft: '20px' }}>
                {renderChildrenReadOnly(item.fields, formState, 1)}
              </div>
            </div>
          );
        }
    
    
    return <React.Fragment key={index}/>;
  })
}




export const FormView = (params: any) => {
  const { formTemplate, formState, print, unboxed } = params;

  useEffect(() => {
    if (!print) return;
    document.body.classList.add('document-print-active');
    return () => {
      document.body.classList.remove('document-print-active');
    };
  }, [print]);

  const form = (
    <div className={`${print ? 'document-print-portal' : ''} ${unboxed ? 'document-form-unboxed' : ''}`.trim()}>
      <div className={`${print ? 'document-print-content' : ''} ${print || unboxed ? '' : 'boxed'}`.trim()}>
        {renderChildrenReadOnly(formTemplate, formState)}
      </div>
    </div>
  );

  if (print) {
    return createPortal(form, document.body);
  }

  return form;
};
  
